"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("~/utils/utils");
const react_redux_1 = require("react-redux");
const selectors_1 = require("~/store/selectors");
const utils_3d_1 = require("~/components/Cad3d/utils/utils.3d");
const BOMItemPrice_scss_1 = __importDefault(require("./BOMItemPrice.scss"));
function BOMItemPrice({ price, discountedPrice }) {
    const isDiscountedPriceShown = (0, react_redux_1.useSelector)(selectors_1.selectBOMDiscountedPriceShown);
    const roundedPrice = Number(price.toFixed(2));
    const roundedDiscountedPrice = Number(discountedPrice === null || discountedPrice === void 0 ? void 0 : discountedPrice.toFixed(2));
    return (react_1.default.createElement("div", { className: BOMItemPrice_scss_1.default.itemPriceContainer }, isDiscountedPriceShown && discountedPrice && (0, utils_3d_1.areNotEqual)(roundedPrice, roundedDiscountedPrice) ? (react_1.default.createElement("div", { className: BOMItemPrice_scss_1.default.itemPriceWithDiscount },
        react_1.default.createElement("div", { className: BOMItemPrice_scss_1.default.itemCrossedOutPrice }, (0, utils_1.formatCurrency)(price, 2)),
        react_1.default.createElement("div", { className: BOMItemPrice_scss_1.default.itemPrice }, (0, utils_1.formatCurrency)(discountedPrice, 2)))) : (react_1.default.createElement("div", { className: BOMItemPrice_scss_1.default.itemPrice }, (0, utils_1.formatCurrency)(price, 2)))));
}
BOMItemPrice.defaultProps = {
    discountedPrice: 0,
};
exports.default = BOMItemPrice;
